import { render } from "./Templates.vue?vue&type=template&id=c62d83bc&scoped=true&ts=true"
import script from "./Templates.vue?vue&type=script&lang=ts"
export * from "./Templates.vue?vue&type=script&lang=ts"

import "./Templates.vue?vue&type=style&index=0&id=c62d83bc&lang=scss&scoped=true"

import exportComponent from "/var/www/tenanthub.au/runners/admin/root/tenanthub-admin/tenanthub-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c62d83bc"]])

export default __exports__